<template>
  <de-layout-content :isCard="true" class="dataModel">
    <el-card class="modelIndex">
      <el-tabs v-model="tabName" @tab-click="tabClick" :class="['tabbar', { 'single': userRole == 'ADMIN' }]">
        <el-tab-pane label="我的模型" name="self" v-if="userRole != 'ADMIN'"></el-tab-pane>
        <el-tab-pane label="系统模型" name="system"></el-tab-pane>
      </el-tabs>
      <div class="tabCont">
        <div class="sideBar">
          <el-form :model="queryParams" ref="queryForm" :inline="true" size="small" class="">
            <el-form-item label="" prop="name" style="width: 100%;margin-right: 0;">
              <div class="searchBar">
                <el-input v-model="queryParams.name" placeholder="输入搜索关键词" style="width: 100%;" @change="$forceUpdate()"></el-input>
                <i class="el-icon-search" @click="handleQuery"></i>
              </div>
              <!-- <el-input v-model="queryParams.name" placeholder="输入搜索关键词" suffix-icon="el-icon-search"
                @keyup.enter.native="handleQuery" @change="$forceUpdate()"></el-input> -->
            </el-form-item>
          </el-form>
          <div class="selectItem" :class="curIndex == index ? 'cur' : ''" v-for="(item, index) in selectList" :key="index"
            @click="handleSelect(index)">
            {{ item.name }}
          </div>
        </div>
        <div class="modelList">
          <div class="spcBt mb20 pr20 listHead">
            <div class="listTitle">{{ selectList[curIndex].name }}</div>
            <el-button type="primary" icon="el-icon-plus" @click="handleAdd()">新增模型</el-button>
          </div>
          <div class="list" v-if="list.length">
            <div class="modelItem" v-for="(item, index) in list" :key="index" @click="handleShow(index, item.id)">
              <div class="imgCont">
                <el-image class="cover" :src="item.thumbnail" fit="cover">
                  <div slot="error" class="image-slot" style="height: 200px;display: flex; align-items: center;flex-direction: column; justify-content: center;">
                    <i class="el-icon-picture-outline"></i>
                    <span class="mt10">暂无数据</span>
                  </div>
                </el-image>
                <div class="mask">
                  <div class="row">
                    <div></div>
                    <div class="flxR">
                      <i class="icon el-icon-edit" @click.stop="handleEdit(item)" v-if="tabName =='system' && userRole == 'ADMIN' || userRole != 'ADMIN' && tabName =='self'"></i>
                      <i class="icon el-icon-setting" @click.stop="handleSetting(item)" v-if="['team','personal','other','testProject'].indexOf(queryParams.applyType) > -1 && (userRole == 'ADMIN' || userRole != 'ADMIN' && tabName =='self')"></i>
                      <i class="icon el-icon-copy-document" @click.stop="handleCopy(item)"></i>
                      <i class="icon el-icon-delete" @click.stop="handleDel(item)" v-if="tabName =='system' && userRole == 'ADMIN' || userRole != 'ADMIN' && tabName =='self'"></i>
                    </div>
                  </div>
                </div>
              </div>
              <div class="others">
                <div class="name mb10">{{ item.name }}</div>
                <div class="time">{{ item.createTime ? moment(item.createTime).format('YYYY-MM-DD HH:mm:ss') : '' }}</div>
              </div>
            </div>
          </div>
          <el-empty description="暂无数据" v-else></el-empty>
        </div>
      </div>
    </el-card>

    <!-- 复制弹窗 -->
    <el-dialog v-dialogDrag title="复制模型" :visible.sync="editPanel.visible" :show-close="true" width="600px">
      <el-form ref="copyForm" :model="editPanel.panelInfo" :rules="rules" label-width="120px">
        <el-form-item label="模型名称:" prop="name">
          <el-input v-model="editPanel.panelInfo.name" clearable size="small" placeholder="请输入模型名称" />
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="editPanel.visible = false">取 消</el-button>
        <el-button type="primary" @click="coypSubmit">确定</el-button>
      </div>
    </el-dialog>

    <!-- 设置弹窗 -->
    <el-dialog title="设置权限" :visible.sync="showSetting" width="800px" append-to-body>
      <div class="settingCont">
        <div class="flxL mr20">
          <el-checkbox v-model="menuNodeAll" @change="selectAll($event)">全选/全不选</el-checkbox>
          <div class="treeCont">
            <el-tree ref="tree" node-key="id" show-checkbox default-expand-all :data="treeData" :props="defaultProps"
              :default-checked-keys="checkKeys" @check-change="getCheck">
            </el-tree>
          </div>
        </div>
        <div class="flxR">
          <div class="preShow">
            <span>已选{{ checkNodes.length }}</span>
            <span class="clear" @click="clearNode">清空</span>
          </div>
          <div class="nodeList">
            <div class="node" v-for="(item, index) in checkNodes" :key="index">{{ item.name }}</div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showSetting = false">取 消</el-button>
        <el-button type="primary" @click="setSubmit">确定</el-button>
      </div>
    </el-dialog>

    <!-- 设置可见人员 -->
    <el-dialog title="设置可见人员" :visible.sync="showVisible" width="800px" append-to-body>
      <div class="settingCont">
        <div class="flxL mr20">
          <el-checkbox v-model="menuNodeAll" @change="selectAllNew($event)">全选/全不选</el-checkbox>
          <div class="treeCont">
            <el-tree ref="userTree" node-key="id" show-checkbox default-expand-all :data="userTree" :props="userProps"
              :default-checked-keys="userCheck" @check-change="checkUser">
            </el-tree>
          </div>
        </div>
        <div class="flxR">
          <div class="preShow">
            <span>已选{{ userNodes.length }}</span>
            <span class="clear" @click="clearNode">清空</span>
          </div>
          <div class="nodeList">
            <div class="node" v-for="(item, index) in userNodes" :key="index">{{ item.name }}</div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showVisible = false">暂不设置</el-button>
        <el-button type="primary" @click="userSubmit">确定</el-button>
      </div>
    </el-dialog>

    <!-- 新建模型 -->
    <el-dialog v-dialogDrag title="新建模型" :visible.sync="showAdd" :show-close="true" width="600px">
      <el-form ref="addForm" :model="addForm" :rules="rules" label-width="120px">
        <el-form-item label="模型名称:" prop="name">
          <el-input v-model="addForm.name" clearable size="small" placeholder="请输入模型名称" />
        </el-form-item>
        <el-form-item label="模型分类:" prop="applyType">
          <el-select v-model="addForm.applyType" placeholder="选择模型分类" disabled>
            <el-option v-for="item in selectList" :key="item.value" :label="item.name" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="模型应用:" prop="applyTo" v-if="addForm.applyType == 'system'">
          <el-radio-group v-model="addForm.applyTo">
            <el-radio label="bureau">体育局</el-radio>
            <el-radio label="center">运动中心</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="应用类型:" prop="applyTo" v-if="addForm.applyType == 'device'">
          <el-radio-group v-model="addForm.applyTo" @change="typeChange">
            <el-radio label="deviceData">设备数据</el-radio>
            <el-radio label="deviceStatistics">统计数据</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="模型应用:" prop="deviceId"
          v-if="addForm.applyType == 'device' && addForm.applyTo == 'deviceData'">
          <el-select v-model="addForm.deviceId" placeholder="选择模型分类" @change="$forceUpdate()">
            <el-option v-for="item in deviceList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        
        <el-form-item label="角色分类:" prop="roleType" v-if="addForm.applyType == 'system'">
          <el-select v-model="addForm.roleType" placeholder="选择角色分类" >
            <el-option v-for="item in roleTypes" :key="item.key" :label="item.value" :value="item.key"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showAdd = false">取 消</el-button>
        <el-button type="primary" @click="addSubmit">确定</el-button>
      </div>
    </el-dialog>
  </de-layout-content>
</template>

<script>

import moment from "moment";
import { groupTree, } from '@/api/panel/panel'
import * as API_DataModel from '@/api/datamodel/index'
import { updateCacheTree } from '@/components/canvas/utils/utils'
import { DEFAULT_COMMON_CANVAS_STYLE_STRING } from '@/views/panel/panel'
const sysList = [
  { name: '系统看板', value: 'system' },
  { name: '设备模型', value: 'device' },
  { name: '团队模型', value: 'team' },
  { name: '运动员模型', value: 'personal' },
  { name: '测试项目模型', value: 'testProject' },
  { name: '其他模型', value: 'other' },
]
const otherList = [
  { name: '团队模型', value: 'team' },
  { name: '运动员模型', value: 'personal' },
  { name: '测试项目模型', value: 'testProject' },
  { name: '其他模型', value: 'other' },
]

export default {
  data() {
    return {
      isAdmin: true,
      tabName: 'system',
      curIndex: 0,
      selectList: [],
      user: this.$store.state.user.user,
      tData: [],
      treeData: [],
      groupForm: {
        name: null,
        pid: null,
        panelType: 'self',
        nodeType: null,
        children: [],
        sort: 'node_type desc,name asc'
      },
      queryParams: {
        name: null,
        queryFrom: 'system',
        applyType: null,
        nodeType: 'panel'
      },
      list: [],
      total: 0,
      loading: false,
      cover: 'https://cube.elemecdn.com/6/94/4d3ea53c084bad6931a56d5158a48jpeg.jpeg',
      editPanel: {
        visible: false,
        optType: null,
        panelInfo: {
          name: null,
          pid: null,
          level: null,
          nodeType: null,
          panelType: null,
          panelData: '[]'
        }
      },
      rules: {
        name: [{ required: true, message: "请输入模型名称", trigger: "blur", }],
        applyType: [{ required: true, message: "请选择模型分类", trigger: "change", }],
        deviceId: [{ required: true, message: "请选择模型应用", trigger: "change", }],
        applyTo: [{ required: true, message: "请选择应用", trigger: "change", }],
        roleType: [{ required: true, message: "请选择角色", trigger: "change", }],
      },
      checkKeys: [],
      userCheck: [],
      checkNodes: [],
      userNodes: [],
      userTree: [],
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      userProps: {
        children: 'children',
        label: 'name',
        id: 'id'
      },
      showVisible: false,
      showSetting: false,
      setForm: {
        orgIds: []
      },
      showAdd: false,
      addForm: {
        name: '',
        applyTo: '',
        applyType: '',
        deviceId: ''
      },
      deviceList: [
        {id:1, name: 'core设备'},
        {id:2, name: 'Hexoskin运动背心'},
        {id:3, name: '铁人IRAP1510'},
        {id:4, name: '阻尼设备'},
        {id:5, name: 'VO2设备'},
      ],
      roleTypes: [],
    };
  },

  methods: {
    moment,
    // getTree() {
    //   groupTree(this.groupForm).then((res) => {
    //     // console.log(res.data);
    //     localStorage.setItem('panel-main-tree', JSON.stringify(res.data || []))
    //     this.tData = res.data || []
    //   })
    // },
    getOrgList() {
      API_DataModel.getOrgList().then(res => {
        // console.log(res)
        if (res.success) {
          // return {...item,item.id:item.orgId}
          this.treeData = res.data.map(item => {
            return { ...item, id: item.orgId }
          })
        }
      })
    },
    // getGroupList() {
    //   API_DataModel.getGroupTree({}).then(res => {
    //     console.log(res);
    //     if (res.code == 200) {
    //       this.userTree = res.data
    //     }
    //   })
    // },
    getDeviceList() {
      API_DataModel.getDeviceList().then(res => {
        console.log(res);
        if (res.code == 200) {
          this.deviceList = res.data.map(item => {
            return {
              id: item.id,
              name: item.name
            }
          })
        }
      })
    },
    _getList() {
      API_DataModel.modelList(this.queryParams).then(res => {
        console.log(res);
        if (res.success) {
          this.list = res.data
        }
      })
    },
    handleQuery() {
      this._getList()
    },
    handleSelect(index) {
      this.curIndex = index
      this.queryParams.name = ''
      this.queryParams.applyType = this.selectList[index].value
      this._getList()
    },
    handleDel(data) {
      const params = {
        title: '确认删除该模型？',
        type: 'danger',
        cb: () => {
          this._del(data.id)
        }
      }
      this.handlerConfirm(params, this.$t('commons.delete'))
    },
    // 复制按钮
    handleCopy(item) {
      this.editPanel.visible = true
      this.editPanel.panelInfo = item
    },
    handleSetting(item) {
      // console.log(item);
      this.setForm.sourceId = item.id
      if(this.userRole == 'SPORT_CENTER_ADMIN' && this.tabName == 'self') {
        this.showVisible = true
        API_DataModel.getAuthedList({ sourceId: item.id, authSourceType: 'panel', authTargetType: 'group'  }).then(res => {
          // console.log(res.data);
          this.showVisible = true
          this.userNodes = res.data
          let userCheck = res.data.map(item => item.id * 1)
          this.userCheck = userCheck
          this.$nextTick(() => {
            this.$refs.userTree.setCheckedKeys(userCheck, true)
          })
        })
      } else {
        API_DataModel.getListByOrg({ panelId: item.id }).then(res => {
          // console.log(res.data);
          this.showSetting = true
          this.checkNodes = res.data
          let checkKeys = res.data.map(item => item.id * 1)
          this.checkKeys = checkKeys
          this.$nextTick(() => {
            this.$refs.tree.setCheckedKeys(checkKeys, true)
          })
        })
      }

    },
    handlerConfirm(options, confirmButtonTextInfo) {
      const { title, content, type = 'danger', cb, confirmButtonText = confirmButtonTextInfo || this.$t('commons.delete'), showCancelButton = true, cancelButtonText = this.$t('commons.cancel'), cancelCb = () => { }, finallyCb = () => { } } = options
      const text = content ? `<span>${this.$t(title)}</span><br><span class="use-html">${this.$t(content)}</span>` : this.$t(title)
      const dangerouslyUseHTMLString = Boolean(content)
      const customClass = `de-confirm de-confirm-fail ${dangerouslyUseHTMLString && 'de-use-html'}`
      const confirmButtonClass = `de-confirm-${type}-btn de-confirm-btn`
      this.$confirm(
        text,
        '',
        {
          confirmButtonText,
          cancelButtonText,
          showCancelButton,
          cancelButtonClass: 'de-confirm-btn de-confirm-plain-cancel',
          dangerouslyUseHTMLString,
          confirmButtonClass,
          customClass,
          iconClass: 'el-icon-warning'
        }
      )
        .then(() => {
          cb()
        })
        .catch((action) => {
          cancelCb(action)
        })
        .finally(() => {
          finallyCb()
        })
    },
    // 接口-删除模型
    _del(id) {
      API_DataModel.delModel(id).then(res => {
        console.log(res);
        this.$message({
          type: 'success',
          message: this.$t('panel.delete_success'),
          showClose: true
        })
        this.clearCanvas()
        updateCacheTree('delete', 'panel-main-tree', id, this.tData)
        this._getList()
      })
    },
    clearCanvas() {
      // 清空当前缓存,快照
      this.$store.commit('setComponentData', [])
      this.$store.dispatch('panel/setPanelInfo', {
        id: null,
        name: '',
        preStyle: null
      })
    },
    handleEdit(data) {
      // console.log(data);
      this.$store.commit('setComponentData', [])
      this.$store.dispatch('panel/setPanelInfo', {
        id: data.id,
        name: data.name,
        privileges: data.privileges,
        sourcePanelName: data.sourcePanelName,
        status: data.status,
        createBy: data.createBy,
        createTime: data.createTime,
        applyType: data.applyType,
        queryFrom: data.queryFrom,
        updateBy: data.updateBy,
        updateTime: data.updateTime,
        watermarkOpen: data.watermarkOpen
      })
      this.$router.push("/dataAnalyse/dataModel/edit");
      // bus.$emit('PanelSwitchComponent', { name: 'PanelEdit' })
    },
    handleShow(index, id) {
      this.$router.push("/dataAnalyse/dataModel/show");
      // setModelParams
      let params = {
        id,
        typeName: this.selectList[this.curIndex].name,
        applyType: this.queryParams.applyType,
        queryFrom: this.tabName,
      }
      this.$store.dispatch('panel/setModelParams', params)
    },
    // 复制弹窗-确认按钮
    coypSubmit() {
      this.$refs["copyForm"].validate((valid) => {
        if (valid) {
          let info = this.editPanel.panelInfo
          let params = {
            id: info.id,
            name: info.name,
            newFrom: 'new',
            nodeType: 'panel',
            optType: 'copy'
          }
          this._copy(params)
        } else {
          console.log("error submit!!");
          this.$message({
            message: "填写数据不全或数据有误",
            type: "error",
          });
          return false;
        }
      });
    },
    // 接口-复制模型
    _copy(params) {
      API_DataModel.modelUpdate(params).then(res => {
        console.log(res);
        if (res.success) {
          this.$message({
            message: "复制成功",
            type: 'success',
            showClose: true
          })
          this.editPanel.visible = false
          this.clearCanvas()
          updateCacheTree('copy', 'panel-main-tree', res.data, this.tData)
          this._getList()
        }
      })
    },
    getCheck() {
      this.checkNodes = this.$refs.tree.getCheckedNodes();
      this.checkKeys = this.checkNodes.map(item => item.orgId)
    },
    checkUser() {
      this.userNodes = this.$refs.userTree.getCheckedNodes().filter(item => item.parentId)
      this.userCheck = this.userNodes.map(item => item.id)
    },
    userSubmit() {
      if (!this.userCheck.length) {
        this.$message({ message: '请设置可见人员', type: 'error' });
        return
      }
      let params = this.setForm
      params.targetIds = this.userCheck
      params.authSourceType = 'panel'
      params.authTargetType = 'group'
      API_DataModel.setSourceAuth(params).then(res => {
        // console.log(res);
        if (res.success) {
          this.$message.success("操作成功");
          this.showVisible = false
          this._getList()
        }
      })
    },
    setSubmit() {
      if (!this.checkKeys.length) {
        this.$message({ message: '请设置模版权限', type: 'error' });
        return
      }
      let params = this.setForm
      params.orgIds = this.checkKeys
      params.authSourceType = 'panel'
      params.authTargetType = 'org'
      API_DataModel.setOrgAuth(params).then(res => {
        // console.log(res);
        if (res.success) {
          this.$message.success("操作成功");
          this.showSetting = false
          this._getList()
        }
      })
    },
    selectAll(value) {
      console.log(value);
      this.$refs.tree.setCheckedNodes(value ? this.treeData : []);
    },
    selectAllNew(value) {
      console.log(value);
      this.$refs.userTree.setCheckedNodes(value ? this.userTree : []);
    },
    clearNode() {
      this.checkKeys = []
      this.checkNodes = []
      this.$nextTick(() => {
        this.$refs.tree.setCheckedKeys([], true)
      })
    },
    handleAdd() {
      this.showAdd = true
      this.addForm = {
        name: null,
        applyType: this.queryParams.applyType,
        applyTo: null,
        level: 1,
        newFrom: 'new',
        nodeType: 'panel',
        panelType: 'self',
        panelStyle: JSON.stringify(DEFAULT_COMMON_CANVAS_STYLE_STRING),
        panelData: '[]'
      }
    },
    typeChange(e) {
      // console.log(e);
      if (e == 'deviceStatistics') {
        this.addForm.deviceId = ''
      }
    },
    addSubmit() {
      // console.log(this.addForm);
      this.$refs["addForm"].validate((valid) => {
        if (valid) {
          this._addModel()
        } else {
          console.log("error submit!!");
          this.$message({
            message: "填写数据不全或数据有误",
            type: "error",
          });
          return false;
        }
      });
    },
    _addModel() {
      API_DataModel.panelSave(this.addForm).then(res => {
        if (res.success) {
          this.$message({
            message: '新建成功',
            type: 'success',
            showClose: true
          })
          // console.log(res.data);
          this.showAdd = false
          this.addJump(res.data)
        }
      })
    },
    addJump(data) {
      this.$store.commit('setComponentData', [])
      this.$store.dispatch('panel/setPanelInfo', {
        id: data.id,
        name: data.name,
        privileges: data.privileges,
        sourcePanelName: data.sourcePanelName,
        status: data.status,
        createBy: data.createBy,
        createTime: data.createTime,
        applyType: data.applyType,
        queryFrom: data.queryFrom,
        updateBy: data.updateBy,
        updateTime: data.updateTime,
        watermarkOpen: data.watermarkOpen
      })
      this.$router.push("/dataAnalyse/dataModel/edit");
    },
    tabClick(tab, event) {
      console.log(tab.name);
      this.queryParams = {
        name: '',
        nodeType: 'panel',
        queryFrom: tab.name,
        applyType: this.selectList[0].value
      }
      this.curIndex = 0
      this._getList()
    },
    getRoleTypes() {
      this.$axios.get(`/api/common/enum/list/roleTypeMap`).then((res) => {
        console.log(res);
        if (res.success) {
          this.roleTypes = res.data;
        }
      });
    }
  },
  created() {
    this.userRole = this.$store.state.user.roles.length && this.$store.state.user.roles[0].name || ''
    if (this.userRole === 'SPORT_CENTER_ADMIN') {
      this.tabName = 'self'
      this.queryParams.queryFrom = 'self'
    }
    this.selectList = this.userRole == 'ADMIN' ? sysList : otherList
    this.queryParams.applyType = this.selectList[0].value
    // this.getTree()
    this.getOrgList()
    this.getRoleTypes()
    // this.getGroupList()
    this.getDeviceList()
    this._getList()
  },
};
</script>

<style lang="scss" scoped>
  ::v-deep .el-tree-node__expand-icon.is-leaf {
    visibility: hidden;
  }
</style>
<style lang='less' scoped>
@import "/src/styles/common/common.less";

.modelIndex {
  height: 100%;
  padding: 20px;
  .el-card__body{
    .el-tabs{
      margin-bottom: 20px;
    }
  }
  ::v-deep .el-card__body {
    display: flex;
    flex-direction: column;
    height: 100%;
    padding: 0;
  }

  .tabbar {
    ::v-deep .el-tabs__header {
      margin: 0;
    }

    ::v-deep .el-tabs__item.is-top {
      padding: 0 20px;
    }
  }

  .tabbar.single ::v-deep .el-tabs__active-bar {
    transform: none !important;
  }

  .tabCont {
    flex: 1;
    min-height: 0;
    display: flex;
  }
}

.sideBar {
  height: 100%;
  width: 240px;
  padding: 10px;
  border-right: 1px solid #f4f4f4;
  .searchBar {
    position: relative;
    width: 220px;
    .el-icon-search {
      position: absolute;
      top: 0;
      right: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 32px;
      width: 32px;
    }
  }
  .selectItem {
    cursor: pointer;
    padding: 0 20px;
    line-height: 48px;
  }

  .selectItem.cur {
    color: #1890FF;
    background-color: rgb(198, 226, 255);
  }
}

.modelList {
  flex: 1;
  min-width: 0;
  height: 100%;
  padding: 16px;
  overflow-y: auto;

  .listTitle {
    font-size: 18px;
    font-weight: bold;
  }

  .list {
    display: flex;
    flex-wrap: wrap;
  }

  .modelItem {
    width: 340px;
    margin: 0 20px 20px 0;
    overflow: hidden;
    border-radius: 5px;

    .imgCont,
    .cover {
      width: 100%;
      height: 200px;

    }
    .cover{
      display: block;
      border: 1px solid rgba(255, 255, 255, .1);
    }

    .imgCont {
      position: relative;
      .image-slot {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        height: 200px;
      }
      .mask {
        display: none;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        padding: 10px;
        z-index: 2;
        background-color: rgba(0, 0, 0, .5);

        .row {
          display: flex;
          align-items: center;
          justify-content: space-between;
        }

        .icon {
          padding: 5px 10px;
          color: #fff;
          font-size: 16px;
        }
      }
    }

    .others {
      width: 100%;
      // height: 156px;
      padding: 20px 24px;
      border: 1px solid #f4f4f4;
      border-top: none;
      background-color: #fff;

      .name {
        color: #333;
      }

      .btn {
        width: 120px;
      }

      .time {
        height: 20px;
        color: #ccc;
        line-height: 20px;
      }
    }

    &:hover {
      .mask {
        display: block;
        background-color: rgba(0, 0, 0, .3) !important;
      }
    }
  }
}



// 1664
@media screen and (min-width: 1310px) and (max-width: 1600px) {

  .list,
  .listHead {
    max-width: 720px;
  }
}

// 2024
@media screen and (min-width: 1600px) and (max-width: 2000px) {

  .list,
  .listHead {
    max-width: 1080px;
  }
}

// 2384
@media screen and (min-width: 2000px) and (max-width: 2380px) {

  .list,
  .listHead {
    max-width: 1440px;
  }
}

@media screen and (min-width: 2380px) {

  .list,
  .listHead {
    max-width: 1800px;
  }
}

.dataModel {
  .el-card{
    background-color: #141937 !important;
    border-radius: 0 !important;
  }
  .tabCont {
    .sideBar {
      border-right: 1px solid rgba(255, 255, 255, .1);

      .selectItem {
        margin: 5px 0;
        line-height: 38px;
      }

      .selectItem.cur {
        background-color: #1890FF;
        color: #fff;
      }
    }
  }

  .modelList {
    .modelItem {
      border-radius: 0 !important;
      .others {
        background-color: #21284B !important;
        border: 1px solid rgba(255, 255, 255, .1);
        padding: 15px 15px;
        .name{
          color: #fff;
        }
        .time{
          color: rgba(255, 255, 255, .5);
        }
      }
    }
  }
}
</style>
